import React, { useState, useMemo } from 'react'
import { Row, Col, FormGroup, Input, Button } from 'reactstrap'
import { isEmpty } from 'lodash'
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js'
import useResponsiveFontSize from '../../../helpers/useResponsiveFontSize'
import { getImageBrandCard } from '../../../helpers/utils'
import candadoSvg from '../../../assets/images/candado.svg'

const useOptions = () => {
  const fontSize = useResponsiveFontSize()
  const options = useMemo(
    () => ({
      style: {
        base: {
          color: '#424770',
          fontSize,
          letterSpacing: "0.025em",
          "::placeholder": {
            color: "#868b8f"
          }
        },
        invalid: {
          color: "#9e2146"
        }
      }
    }),
    [fontSize]
  )
  return options
}

const CardForm = ({
  loading,
  stripe,
  setCardHolderName,
  cardHolderName,
  pay
}) => {
  const options = useOptions()

  const [brandOfCard, setBrandOfCard] = useState('')
  const [cardInputInvalid, setCardInputInvalid] = useState(true)
  const [expirationInputInvalid, setExpirationInputInvalid] = useState(true)
  const [cvvInputInvalid, setCvvInputInvalid] = useState(true)

  return (
    <React.Fragment>
      <div className="cart-card">
        <Row>
          <h3 className="cart-card-title">Información de pago</h3>
        </Row>
        <Row>
          <Col sm="12">
            <FormGroup>
              <label style={{ width: '100%' }}>
                Nombre en tarjeta
                <Input
                  type="text"
                  name="cardHolderName"
                  id="cardHolderName"
                  className="StripeElement input-like-stripe"
                  required
                  value={cardHolderName}
                  placeholder="Nombre..."
                  onChange={(event) => {
                    setCardHolderName(event.target.value.toUpperCase())
                  }}
                />
              </label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <FormGroup>
              <label>
                Número de tarjeta
              </label>
              <CardNumberElement
                options={options}
                onChange={event => {
                  setBrandOfCard(event.brand)
                  if (event.empty || !event.complete || !isEmpty(event.error)) {
                    setCardInputInvalid(true)
                  } else {
                    setCardInputInvalid(false)
                  }
                }}
              />
              <div style={{ right: '15px', position: 'absolute', top: '30px' }}>
                {
                  !isEmpty(brandOfCard) && !isEmpty(getImageBrandCard(brandOfCard)) && (
                    <img
                      src={getImageBrandCard(brandOfCard)}
                      style={{ marginLeft: '15px' }}
                      alt={brandOfCard}
                      height="50px"
                    />
                  )
                }
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm="8">
            <FormGroup>
              <label style={{ width: '100%' }}>
                Fecha de expiración
                <CardExpiryElement
                  options={options}
                  onChange={event => {
                    if (event.empty || !event.complete || !isEmpty(event.error)) {
                      setExpirationInputInvalid(true)
                    } else {
                      setExpirationInputInvalid(false)
                    }
                  }}
                />
              </label>
            </FormGroup>
          </Col>
          <Col sm="4">
            <FormGroup>
              <label style={{ width: '100%' }}>
                CVC
                <CardCvcElement
                  options={options}
                  onChange={event => {
                    if (event.empty || !event.complete || !isEmpty(event.error)) {
                      setCvvInputInvalid(true)
                    } else {
                      setCvvInputInvalid(false)
                    }
                  }}
                />
              </label>
            </FormGroup>
          </Col>
        </Row>
      </div>

      <div className="cart-card">
        <Row>
          <Col sm="12" style={{ color: '#34c38f', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={candadoSvg}
              alt="Vendora | Más que un negocio, un movimiento"
              height={34}
              style={{ alignSelf: 'center' }}
            />
            <div style={{ textAlign: 'justify', marginLeft: '10px' }}>
              Todos tus datos personales y bancarios dentro de Vendora están protegidos por los más altos estándares de seguridad bancaria.
            </div>
          </Col>
        </Row>
      </div>
      <div className="cart-card">
        <Row className="text-center">
          <Col sm="12">
            <Button
              onClick={() => {
                window.analytics.track(`Order placed`)
                pay()
              }}
              style={{ width: '100%' }}
              color="primary"
              className="btn btn-success waves-effect waves-light mb-2 mr-2"
              disabled={!stripe || isEmpty(cardHolderName) || cardInputInvalid || expirationInputInvalid || cvvInputInvalid || loading}>
              <i className="mdi mdi-lock mr-1"></i> PAGAR PEDIDO
            </Button>
          </Col>
          <Col>
            Al realizar tu pedido, aceptas el <a href="https://vendora.com.mx/privacidad/" className="link-devoluciones">aviso de privacidad</a> y las <a href="https://vendora.com.mx/terminos/" className="link-devoluciones">condiciones de uso</a> de Vendora.
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default CardForm
